import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AssetLoadService from "../../../core/assetloading/AssetLoadService";
import NPCModel from "../../scenario/NPCModel";
import AbstractContentIndicatorButtonMediator from "./AbstractContentIndicatorButtonMediator";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class EmailConversationListItemMediator extends AbstractContentIndicatorButtonMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SoundManager} soundManager 
     * @param {NPCModel} npcModel 
     * @param {AssetLibrary} assetLibrary 
     * @param {AssetLoadService} assetLoadService 
     */
    constructor(target, dispatcher, soundManager, npcModel, assetLibrary, assetLoadService) {
        super(target, dispatcher, soundManager);

        this._npcModel = npcModel;
        this._assetLibrary = assetLibrary;
        this._assetLoadService = assetLoadService;

        this._conversation = this._target.conversation;
        this._smallNpcImages = this.getCustomData().smallNpcImages;
    }

    initialize() {
        super.initialize();

        if (this._conversation.hasUnreadItems()) {
            this._target.gotoAndStop("new");
        } else {
            this._target.gotoAndStop("opened");
        }

        this._target.noPortraitThumb.mouseEnabled = false;

        this._target.subjectTextField.mouseEnabled = false;
        this._target.nameTextField.mouseEnabled = false;
       
        let firstItem = this._conversation.getItems()[0];
        let sender = firstItem.content.getSender();
        let subject = firstItem.content.getSubject();
        this._target.nameTextField.text = isNull(sender) ? "" : this._npcModel.getDisplayNameForNpcId(sender);
        this._target.subjectTextField.text = isNull(subject) ? "" : subject;

        const npc = this._npcModel.getNpcByNpcID(sender);
        if (npc) {
            const npcImage = npc.getImage();
            if (npcImage) {
                const id = this._smallNpcImages ? `${npcImage}_small` : npcImage;
                const image = this._smallNpcImages ?  `assets/images/npcs/${npcImage}_small.png` :  `assets/images/npcs/${npcImage}.png`;
                this._loadAndShowImage(id, image);
            }
        }
    }

    destroy() {
        super.destroy();
        
        this._conversation = null;
    }

    _loadAndShowImage(id, url) {
        if (this._assetLibrary.hasAsset(id)) {
            this._onImageLoaded(id, false);
            return;
        }

        this._assetLoadService.lazyLoadImage(id, url, this._onImageLoaded.bind(this));
    }

    _onImageLoaded(assetId, animated = true) {
        const image = this._assetLibrary.getAsset(assetId);
        const bitmap = new createjs.Bitmap(image);
        this._target.imageContainer.addChild(bitmap);

        if (animated) {
            bitmap.alpha = 0;

            createjs.Tween.get(bitmap)
                .to({ alpha: 1 }, 150, createjs.Ease.sineInOut)
                .call(() => {
                    this._target.noPortraitThumb.visible = false;
                });
        } else {
            this._target.noPortraitThumb.visible = false;
        }
    }

    get skin() {
        return this._target;
    }
}